module.exports = __webpack_public_path__ + "img/clientes-slick.762d3bba.svg";